export default __webpack_public_path__ + "static/media/catalog_point_img04.74e6d97b.svg";